var map = {
	"./instagram-a.svg": 81563,
	"./messenger-a.svg": 7273,
	"./messenger-b.svg": 27420,
	"./messenger-c.svg": 6403,
	"./web-a.svg": 51511,
	"./whatsapp-a.svg": 2530,
	"./whatsapp-b.svg": 47617,
	"./whatsapp-c.svg": 76159,
	"./whatsapp-d.svg": 70184,
	"./whatsapp-e.svg": 79394,
	"./whatsapp-f.svg": 11580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42740;